export function PCPointPart03() {
  return (
    <div className='w-full bg-primary-600 d-px-[40px]'>
      <div className='max-w-[1000px] w-full mx-auto flex flex-col d-py-[80px]'>
        <h2 className='text-center d-text-[32px] d-leading-[58px] d-tracking-[3.2px] font-semibold'>
          Comadoアプリを使って
          <br />
          ポイントを獲得しよう
        </h2>
        <div className='relative flex justify-center'>
          <img
            src='/images/assets/get_start_qr/bg@pc.webp'
            alt='Comadoアプリを使ってポイントを獲得しよう'
            className='d-w-[1000px] d-h-[436px] d-mt-[24px] object-contain'
          />
          <img
            src='/images/assets/get_start_qr/qr_point.webp'
            alt='アプリを早速使ってみようQR'
            className='object-contain d-w-[170px] d-h-[170px] absolute z-10 d-bottom-[85px]'
          />
        </div>
      </div>
    </div>
  )
}
